module.exports = __webpack_public_path__ + "img/install_03.7bdddf97.jpg";